// RDS
import Heading from '@ramsey-design-system/heading';
import Button from '@ramsey-design-system/button';
import Text from '@ramsey-design-system/text';

function EveryDollarCallToAction() {
  return (
    <div className="gap-lg mb-4 flex w-full justify-between rounded-lg bg-white p-4 shadow-sm">
      <div className="max-w-[385px]">
        <Heading level="2" className="text-6 !leading-reset sm:text-7 mb-2">
          Create your budget with EveryDollar!
        </Heading>
        <Text color="subdued" className="text-3 sm:text-4 mb-2 text-gray-50">
          EveryDollar helps you tell your money where to go instead of wondering
          where it went.
        </Text>
        <Button
          element="a"
          target="_blank"
          href="https://everydollar.onelink.me/7YvT/94e0435d"
          size="large"
        >
          Go To My Budget
        </Button>
      </div>
      <img
        src="https://cdn.ramseysolutions.net/media/ramsey-plus/app/budget/never-budgeted.svg"
        className="hidden w-[80px] sm:block sm:w-[120px]"
        alt=""
      />
    </div>
  );
}

export default EveryDollarCallToAction;
